// extracted by mini-css-extract-plugin
export default {"icon":"styles_icon__Yh2Ub","last-sync-date":"styles_last-sync-date__gOQ-K","sync-button":"styles_sync-button__SdzeV"};